import { PdfSubSuperScript } from './../enumerator';
export class _PdfFontMetrics {
    constructor() {
        this._lineGap = 0;
    }
    _getAscent(format) {
        return this._ascent * 0.001 * this._getSize(format);
    }
    _getDescent(format) {
        return this._descent * 0.001 * this._getSize(format);
    }
    _getLineGap(format) {
        return this._lineGap * 0.001 * this._getSize(format);
    }
    _getHeight(format) {
        let height;
        const clearTypeFonts = ['cambria', 'candara', 'constantia', 'corbel', 'cariadings'];
        const clearTypeFontCollection = [];
        clearTypeFontCollection.push(...clearTypeFonts);
        if (this._getDescent(format) < 0) {
            height = (this._getAscent(format) - this._getDescent(format) + this._getLineGap(format));
        }
        else {
            height = (this._getAscent(format) + this._getDescent(format) + this._getLineGap(format));
        }
        return height;
    }
    _getSize(format) {
        let size = this._size;
        if (format !== null && typeof format !== 'undefined') {
            switch (format.subSuperScript) {
                case PdfSubSuperScript.subScript:
                    size /= this._subScriptSizeFactor;
                    break;
                case PdfSubSuperScript.superScript:
                    size /= this._superscriptSizeFactor;
                    break;
            }
        }
        return size;
    }
}
export class _WidthTable {
}
export class _StandardWidthTable extends _WidthTable {
    constructor(widths) {
        super();
        this.widths = widths;
    }
    _itemAt(index) {
        if (index < 0 || index >= this.widths.length) {
            throw new Error('The character is not supported by the font.');
        }
        return this.widths[index];
    }
    _toArray() {
        return this.widths;
    }
}
export class _CjkWidthTable extends _WidthTable {
    constructor(defaultWidth) {
        super();
        this._defaultWidth = defaultWidth;
        this.widths = [];
    }
    _itemAt(index) {
        let width = this._defaultWidth;
        this.widths.forEach((entry) => {
            if (index >= entry._from && index <= entry._to) {
                width = entry._itemAt(index);
            }
        });
        return width;
    }
    _toArray() {
        const array = [];
        this.widths.forEach((width) => {
            width._appendToArray(array);
        });
        return array;
    }
    _add(width) {
        this.widths.push(width);
    }
}
export class _CjkWidth {
}
export class _CjkSameWidth extends _CjkWidth {
    constructor(from, to, width) {
        super();
        this._widthFrom = from;
        this._widthTo = to;
        this._width = width;
    }
    get _from() {
        return this._widthFrom;
    }
    get _to() {
        return this._widthTo;
    }
    _itemAt(index) {
        if (index < this._from || index > this._to) {
            throw new Error('Index is out of range.');
        }
        return this._width;
    }
    _appendToArray(array) {
        array.push(this._from, this._to, this._width);
    }
}
export class _CjkDifferentWidth extends _CjkWidth {
    constructor(from, widths) {
        super();
        this._widthFrom = from;
        this._widths = widths;
    }
    get _from() {
        return this._widthFrom;
    }
    get _to() {
        return this._widthFrom + this._widths.length - 1;
    }
    _itemAt(index) {
        if (index < this._widthFrom || index > this._to) {
            throw new Error('Index is out of range.');
        }
        return this._widths[index];
    }
    _appendToArray(array) {
        array.push(this._from);
        array.forEach((entry) => {
            array.push(entry);
        });
    }
}
